export { default as ProductsIndexContentLayout } from './ProductsIndexContentLayout';
